import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import TheTrackRecord from "./sections/TheTrackRecord";
import CustomerReviews from "./sections/CustomerReviews";
import InvestmentTiers from "./sections/InvestmentTiers";
import TheEngineeringMindset from "./sections/TheEngineeringMindset";
import PretADigitaliserVotreLogistique from "./sections/PretADigitaliserVotreLogistique";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <TheTrackRecord />
      <CustomerReviews />
      <InvestmentTiers />
      <TheEngineeringMindset />
      <PretADigitaliserVotreLogistique />
      <Footer />
    </div>;
}